// extracted by mini-css-extract-plugin
export default {"homeContainer":"TermsPage_homeContainer__bVCJt","footerContent":"TermsPage_footerContent__uHlFu"};